import type { ManifestOption } from './types';
import type { OptionHTMLAttributes } from 'react';

export const mapManifestOptionsToHtmlOptions = (
  options?: ManifestOption[],
): OptionHTMLAttributes<HTMLOptionElement>[] =>
  options?.map(({ value, label }) => ({
    value: value,
    children: label,
  })) ?? [];
